/**
 *  @author:        Julie Branyan - julie.branyan@cloud4good.com
 *  @description:   Builds the testimonial component.
 *
 *  History
 *  <Date>        <Author Name>       <Reference #>       <Change Description>
 *  2024-05-30    Julie Branyan       CFG-215              Initial creation
*/

'use strict';

var carousel = require('../components/normalizeCarouselHeight');

module.exports = {

    // when page is loaded, normalize testimonial carousel height to prevent jumping heights
    normalizeTestimonialCarousel : function() {
        $(window).on('load', function() {
            var items   = $('#testimonialCarousel .carousel-item');// grab all the slides
            var carouselInner   = $('#testimonialCarousel .carousel-inner');// grab all the slides
            carousel.normalizeCarouselHeight(items, carouselInner);
        });
    }
};